import React from 'react';
import { Meteor } from 'meteor/meteor';
import { CirclePicker } from 'react-color';

import {
	Tooltip,
	OverlayTrigger
} from '@sketchpixy/rubix';

export class FlightTypeColor extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			flightType : props.flightType,
			tooltip: ''
			//tooltip : <Tooltip id='link-tooltip'>{props.flightType.title}</Tooltip>
		};

	}

	render() {

		if(!this.state.flightType.color) {
			return (
				<div className="flight-type-color" style={{backgroundColor: this.state.flightType}}>&nbsp;</div>
			)
		}

		return (
			<div className="flight-type-color" style={{backgroundColor: this.state.flightType.color}}>&nbsp;</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/reservations/components/flightTypeColorComponent.js
 **/